import React, { useEffect } from 'react';
import classNames from 'classnames';
import {
  Box,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';
import AppBar from '../../../components/appBar';

import styles from './Result.styles';
import { ResultDispatchFunc } from './types';
import ResultFilter from './resultFilter';
import ResultTable from './resultTable';
import MainMenu from '../main/mainMenu';
import { LoginInfo } from '../login/types';
import ResultCard from './resultCard';

const useStyles = makeStyles(styles);

type Props = {
  className?: string;
  title?: string;
  initialize: ResultDispatchFunc<unknown>;
  loginStatus?: LoginInfo;
};

const Result: React.FC<Props> = ({
  className,
  title,
  initialize,
  loginStatus,
}: Props) => {
  const classes = useStyles();

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <Box className={classNames(classes.root, className)}>
      <Helmet>
        <title>
          {title || 'Result'}
        </title>
      </Helmet>
      <AppBar
        title={title || 'Result'}
      >
        <MainMenu />
      </AppBar>
      <Box className={classes.detailsPanel}>
        <Box className={classes.body}>
          {loginStatus?.data?.mode === 'place' && (
            <>
              <ResultFilter />
              <ResultTable />
            </>
          )}
          {loginStatus?.data?.mode === 'person' && (
            <>
              <ResultCard />
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Result;
